import api from 'configs/api';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import { ISerialNumber } from 'interfaces/serialNumber';

export const postSerialNumbers = async (params: {
  installationId: string[];
}) => {
  const url = '/prediction/serie-number-filter';
  const { data } = await api.post<IRequestListResponse<ISerialNumber>>(
    url,
    params,
  );
  return data;
};
